'use client'

import React from 'react'
import Image from 'next/image'
import { useProductContext } from '@context/ProductContext/ProductContext' // Update the path accordingly
import styles from './accordion.module.scss'

const ImageComponent = ({ withImage, firstItem }) => {
  const { AccordianItem } = useProductContext()

  return (
    withImage && (
      <div className={styles.imageContainer}>
        <div className={styles.imageWrapper}>
          {/* Load the image dynamically based on the selected item */}
          <Image
            src={
              AccordianItem?.accordionImage?.data?.attributes?.url || firstItem?.accordionImage?.data?.attributes?.url
            }
            alt="Image Accordion"
            width={596}
            height={666}
            className={styles.image}
            loading="lazy"
          />
        </div>
      </div>
    )
  )
}

export default ImageComponent
